import { Modal } from "flowbite-react";
import FormDeletePayment from "../form/FormDeletePayments";
import { useToastContext } from "../../../../../../../common/components/ui/toast/toast.context";
import { restorePayment } from "../../../../../../../common/services/payments.api";

type Props = {
  paymentId: string;
  renterId: string;
  onClose: () => void;
}

export default function ModalRestorePayments(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const handleCloseModal = () => { props.onClose(); };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async function restorePayments(data: any) {

    const result = await restorePayment(props.paymentId, data);

    if (result.ok) {
      notifySuccess('Pagamento restaurado com sucesso!');
    }

    if (!result.ok) {
      notifyError(result.message as string)
    }

    return result;
  }

  return (
    <Modal
      className='relative dark:text-black'
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header>
        <div className="flex items-center justify-start gap-3">
          <span className='text-black'>
            {`Remover Pagamento`}
          </span>
        </div>
      </Modal.Header>
      <Modal.Body >
        <FormDeletePayment
          paymentId={props.paymentId}
          renterId={props.renterId}
          onClose={handleCloseModal}
          onSave={(paymentId) => paymentId}
          onSubmit={restorePayments}
          reason="Motivo da restauração"
        />

      </Modal.Body>
    </Modal>
  )

}